import { useEffect, useState } from "react";
import { getOurClassesService } from "../api/landingClass.service";
import { mapOurClassToCategory } from "../api/landingClass.mappers";
import type { LandingCategory } from "../types/landing.types";

interface UseOurClassesResult {
  categories: LandingCategory[];
  isLoading: boolean;
  error: string | null;
  refetch: () => void;
}

export function useOurClasses(): UseOurClassesResult {
  const [categories, setCategories] = useState<LandingCategory[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [tick, setTick] = useState(0);

  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      setIsLoading(true);
      setError(null);
      try {
        const response = await getOurClassesService();
        if (cancelled) return;
        const rows = response.data ?? [];
        setCategories(rows.map(mapOurClassToCategory));
      } catch {
        if (cancelled) return;
        setError("Unable to load classes. Please try again.");
        setCategories([]);
      } finally {
        if (!cancelled) {
          setIsLoading(false);
        }
      }
    };

    void load();
    return () => {
      cancelled = true;
    };
  }, [tick]);

  return {
    categories,
    isLoading,
    error,
    refetch: () => setTick((n) => n + 1),
  };
}
